import { render, staticRenderFns } from "./ValidatedTextAreaInput.vue?vue&type=template&id=61a33985&scoped=true&"
import script from "./ValidatedTextAreaInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ValidatedTextAreaInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ValidatedTextAreaInput.vue?vue&type=style&index=0&id=61a33985&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a33985",
  null
  
)

export default component.exports